export enum AuditLogsTier1 {
  StaffHubSettings = "StaffHub Settings",
  SuperAdminSettings = "SuperAdmin Settings",
  FamilySettings = "Family Settings",
  Calendar = "Calendar",
  ContentManager = "Content Manager",
  Settings = "Settings",
  Maintenance = "Maintenance",
  Insights = "Insights",
  Residents = "Residents",
  FamilyMembers = "Family Members",
  FamilyFeedback = "Family Feedback",
  LifestylePrograms = "Lifestyle Programs",
  DigitalSignage = "Digital Signage",
  Concierge = "Concierge",
}

export enum AuditLogsTier2 {
  StaffSettings = "Staff Settings",
  DigitalSignage = "Digital Signage",
  Concierge = "Concierge",
  Lifestyle = "Lifestyle",
  CommunicationManagement = "Communication Management",
  DailyCareUpdates = "Daily care updates",
  Other = "Other",
  MainContact = "Main Contact",
  CareAccess = "Care Access",
  Activity = "Activity",
  Kiosk = "Kiosk",
  FormTemplates = "Form Templates",
  ScheduledJob = "Scheduled Job",
  JobRequest = "Job Request",
  SurveyCentre = "Survey Centre",
  Surveys = "Surveys",
  Maintenance = "Maintenance",
  Entertainment = "Entertainment",
  Gallery = "Gallery",
  List = "List",
  LifestyleProgram = "Lifestyle Program",
  Resident = "Resident",
  FamilyMember = "Family Member",
  Request = "Request",
  Event = "Event",
  Product = "Product",
  BookingOrders = "Booking & Orders",
}

export enum AuditLogsTier3 {
  UserProfile = "User Profile",
  UserManagement = "User Management",
  Facility = "Facility",
  EmailTemplates = "Email Templates",
  MailingLists = "Mailing Lists",
  ResidentDeparturesTransfers = "Resident Departures Transfers",
  GroupingsAndLocs = "Groupings & Locs",
  Vendors = "Vendors",
  FamilyNewsletter = "Family Newsletter",
  Dimension = "Dimension",
  Maintenance = "Maintenance",
  ResidentTags = "Resident Tags",
  Activities = "Activities",
  Care = "Care",
  Noticeboard = "Noticeboard",
  ContentManagerDigitalSignage = "Content Manager - Digital Signage",
  ContentManager = "Content Manager",
  DevicesColumn = "Devices Column",
  FamilyHubConcierge = "Family Hub Concierge",
  MyHubConcierge = "MyHub Concierge",
  CanFamilyChargeToRoom = "Can family charge to room",
  CanFamilyPayByCard = "Can family pay by card",
  VendorsMarkServiceRequestsComplete = "Vendors can mark service requests as complete",
  ConciergeServices = "Concierge Services",
  Events = "Events",
  ResidentCalendarTile = "Resident Calendar Tile",
  Community = "Community",
  OptInLifestylePrograms = "Opt in Lifestyle Programs",
  LifestylePrograms = "Lifestyle Programs",
  LocationBooking = "Location Booking",
  EnableVirtualEvents = "Enable Virtual events",
  PrintableCalendar = "Printable calendar",
  JsonCalendarFeed = "Json calendar feed",
  ResidentEventPictures = "Resident Event Pictures",
  WeeklyLifestyleEventsReport = "Weekly lifestyle events report",
  CreateWingsFromEvents = "Can create wings from events",
  Calendar = "Calendar",
  RealTimeAudioVideoCalls = "Real time audio/video calls",
  FamilyChats = "Family chats",
  InstantCalls = "Instant calls",
  ScheduledCalls = "Scheduled calls",
  TakePhoto = "Take photo",
  CommunityMessageBoard = "Community message board",
  FamilyCanSeeNameOfStaff = "Family can see name of staff",
  StaffCanMessageFamily = "Staff can message family",
  EnableResidentChat = "Enable resident chat",
  DisplayMessageboardTile = "Display Messageboard tile",
  FamilyHubCareTab = "FamilyHub Care tab",
  CareSummary = "Care Summary",
  DailyPlan = "Daily plan",
  DailyCare = "Daily Care",
  CarePlan = "Care Plan",
  Concierge = "Concierge",
  Messenger = "Messenger",
  SharePhotoGallery = "Share photo gallery",
  ShareToMCareNotes = "Share to mCare notes",
  ResidentReligiousAffiliation = "Resident religious affiliation",
  MyHubFriendsFromOtherCommunities = "MyHub friends from other communities",
  StaffCanLoginOnBehalf = "staff can log in on behalf of resident",
  StaffAppNotificationsForAll = "StaffApp notifications for all residents",
  DisplayBirthdays = "Display birthdays",
  CanInviteFamilyMembers = "Can invite family members",
  ResidentConsentCheckbox = "Resident consent checkbox",
  ResidentsUseOwnDevice = "Residents can use their own device",
  ResidentsHaveMultipleDevices = "Residents can have more than one device",
  StaffAppNotifications = "StaffApp notifications",
  ResidentImport = "Resident Import",
  ResidentAddDelete = "Resident add/delete",
  ResidentCanInviteFamily = "Resident can invite family",
  AdtAutomation = "ADT Automation",
  CommunityTileDirectoryListWing = "Community tile directory list wing display",
  CommunityTileDirectoryDetailedInfo = "Community tile directory detailed info display",
  StaffDirectory = "Staff directory",
  Dashboard = "Dashboard",
  ResidentAndFamilyDirectory = "Resident directory and family directory",
  ContentManagerGallery = "Content manager - gallery",
  InsightsSurveys = "Insights - Surverys",
  ContentLibrary = "Content library",
  Media = "Media",
  ContentManagerMediaLibrary = "Content Manager - media library",
  CommunityDining = "Community Dining",
  VirtualGuestbook = "Virtual Guestbook",
  VoiceAssistant = "Voice assistant",
  FamilyCanBookVisits = "Family can self book visits",
  MyBudgets = "My Budgets",
  ResidentDailyCheckIn = "Resident daily check in",
  DisplayMenuTile = "Display menu tile",
  InsightsReporting = "Insights - Reporting",
  Guestbook = "Guestbook",
  DocumentsStaffHub = "Documents - StaffHub",
  DocumentsMyHub = "Documents - MyHub",
  Kiosk = "Kiosk",
  StaffApi = "Staff API",
  ContactsApi = "Contacts API",
  MyHubFamilyTile = "MyHub Family tile",
  EnableFamilyToResidentMessaging = "Enable Family to Resident messaging",
  Fpoa = "FPOA",
  Wpoa = "WPOA",
  Epoa = "EPOA",
  ConsentToShareInfo = "Consent to share info",
  CareTab = "Care Tab",
  Chat = "Chat",
  CreateEvent = "Create Event",
  DeleteEvent = "Delete Event",
  AmendEvent = "Amend Event",
  PublishDraft = "Publish Draft",
  AddImage = "Add image",
  AddFolder = "Add folder",
  DeleteImage = "Delete image",
  DeleteFolder = "Delete Folder",
  AssignDevice = "Assign a device",
  UnassignDevice = "Unassign device",
  Add = "Add",
  Remove = "Remove",
  Amend = "Amend",
  PublishSurvey = "Publish survey",
  ArchiveSurvey = "Archive Survey",
  Intercom = "Intercom support",
  Imports = "Imports",
  Impersonation = "Impersonation",
  BookRequest = "Book Request",
  BookEvent = "Book Event",
  BookProduct = "Book Product",
  CompleteRequest = "Complete Request",
  CompleteEvent = "Complete Event",
  CompleteProduct = "Complete Product",
  RejectRequest = "Reject Request",
  RejectEvent = "Reject Event",
  RejectProduct = "Reject Product",
  FeatureDigitalSignage = "Feature Digital Signage",
  FeatureLifestyle = "Lifestyle",
  Security = "Security"
}
